import React from "react";

const Icons = () => (
  <svg
    width="0"
    height="0"
    aria-hidden="true"
    style={{ position: "absolute" }}
    focusable="false"
  >
    <symbol id="i-chev-down" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 9l6 6 6-6"
      ></path>
    </symbol>
    <symbol id="i-chev-left" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 6l-6 6 6 6"
      ></path>
    </symbol>
    <symbol id="i-chev-right" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 6l6 6-6 6"
      ></path>
    </symbol>
    <symbol id="i-lock" viewBox="0 0 24 24">
      <rect
        x="4"
        y="10.5"
        width="16"
        height="10"
        rx="2.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      ></rect>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        d="M8 10.5V7.5a4 4 0 0 1 8 0v3"
      ></path>
    </symbol>
    <symbol id="i-x" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        d="M6 6l12 12M18 6L6 18"
      ></path>
    </symbol>
    <symbol id="i-check" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 13l4 4 10-11"
      ></path>
    </symbol>
    <symbol id="i-retry" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        d="M20 11a8 8 0 1 0-1.5 4.7"
      ></path>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 4v6h-6"
      ></path>
    </symbol>
    <symbol id="i-clock" viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="8.5"
        fill="none"
        stroke="currentColor"
      ></circle>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 7.5V12l3 2"
      ></path>
    </symbol>
    <symbol id="i-home" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 11l8-7 8 7M6 10v9h12v-9"
      ></path>
    </symbol>
    <symbol id="i-play" viewBox="0 0 24 24">
      <path d="M7 5v14l12-7z"></path>
    </symbol>
    <symbol id="i-vol" viewBox="0 0 24 24">
      <path d="M4 9v6h4l5 4V5L8 9zM16 8a5 5 0 0 1 0 8"></path>
    </symbol>
    <symbol id="i-spark" viewBox="0 0 32 32">
      <path
        d="M16 4 L17.8 12.2 L26 14 L17.8 15.8 L16 24 L14.2 15.8 L6 14 L14.2 12.2 Z"
        fill="#F5B041"
        fillOpacity=".25"
        stroke="#C4841D"
        strokeWidth="2"
        strokeLinejoin="round"
      ></path>
      <path
        d="M24 22 L24.6 24.4 L27 25 L24.6 25.6 L24 28 L23.4 25.6 L21 25 L23.4 24.4 Z"
        fill="#C4841D"
      ></path>
      <path
        d="M7 5 L7.5 6.8 L9.3 7.3 L7.5 7.8 L7 9.6 L6.5 7.8 L4.7 7.3 L6.5 6.8 Z"
        fill="#C4841D"
      ></path>
    </symbol>
    <symbol id="i-spark-sun" viewBox="0 0 24 24">
      <path
        fill="#F3EC7A"
        d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z"
      ></path>
    </symbol>
    <symbol id="i-books" viewBox="0 0 24 24">
      <rect
        x="4"
        y="4.6"
        width="16"
        height="4.3"
        rx="1.3"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      ></rect>
      <rect
        x="4"
        y="9.85"
        width="16"
        height="4.3"
        rx="1.3"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      ></rect>
      <rect
        x="4"
        y="15.1"
        width="16"
        height="4.3"
        rx="1.3"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      ></rect>
    </symbol>
    <symbol id="i-user" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 12a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4zM4.5 20a7.5 7.5 0 0 1 15 0 .9.9 0 0 1-.9.9H5.4a.9.9 0 0 1-.9-.9z"
      ></path>
    </symbol>
    <symbol id="i-bell" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6M10 19a2 2 0 0 0 4 0"
      ></path>
    </symbol>
    <symbol id="i-chat" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 5h16v11H9l-4 3v-3H4z"
      ></path>
    </symbol>
    <symbol id="i-dots" viewBox="0 0 24 24">
      <circle cx="12" cy="5" r="1.9" fill="currentColor"></circle>
      <circle cx="12" cy="12" r="1.9" fill="currentColor"></circle>
      <circle cx="12" cy="19" r="1.9" fill="currentColor"></circle>
    </symbol>
    <symbol id="i-upload" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 16V5m-4 4 4-4 4 4M5 19h14"
      ></path>
    </symbol>
    <symbol id="i-like" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        d="M7 10.5 11 3a2.2 2.2 0 0 1 2.1 2.7L12.3 9H19a2 2 0 0 1 2 2.4l-1.2 6A2.2 2.2 0 0 1 17.6 19H7zM7 10.5V19H4.5A1.5 1.5 0 0 1 3 17.5v-5.5A1.5 1.5 0 0 1 4.5 10.5H7z"
      ></path>
    </symbol>
    <symbol id="i-heart" viewBox="0 0 24 24">
      <path
        d="M12 21C7 16.5 3 13 3 8.6 3 5.9 5.2 4 7.5 4 9.5 4 11 5.3 12 7 13 5.3 14.5 4 16.5 4 18.8 4 21 5.9 21 8.6 21 13 17 16.5 12 21Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol id="i-reply" viewBox="0 0 24 24">
      <path d="M9 7L4 12l5 5M4 12h11a5 5 0 0 1 5 5v1"></path>
    </symbol>
    <symbol id="i-cog" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1"></path>
    </symbol>
    <symbol id="i-doc" viewBox="0 0 24 24">
      <path d="M7 3h7l4 4v14H7zM14 3v4h4"></path>
    </symbol>
    <symbol id="i-logout" viewBox="0 0 24 24">
      <path d="M9 21H5V3h4M14 16l4-4-4-4M18 12H8"></path>
    </symbol>
    <symbol id="i-send" viewBox="0 0 24 24">
      <path d="M4 12l16-7-7 16-2-7z"></path>
    </symbol>
    <symbol id="i-refresh" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 12a8 8 0 0 1 14.5-4.5M18.5 3v4.5H14M20 12a8 8 0 0 1-14.5 4.5M5.5 21v-4.5H10"
      ></path>
    </symbol>
    <symbol id="i-fire" viewBox="0 0 32 32">
      <path
        fill="none"
        stroke="#C4841D"
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="round"
        d="M16 3 C 17 6 19 8 19 11 C 19 13 17.5 14 16.5 14 C 16 12.5 16.5 11 17 10 C 14 11 13 14 13 16 C 13 17.5 14 18.5 14 19 C 12.5 18 11.5 16.5 11 15 C 9.5 17.5 9 20 9 22 C 9 26 12 29 16 29 C 21 29 24 26 24 22 C 24 18 22 15.5 20.5 13 C 19.5 11 18.5 9 18 7 C 17.5 5 16.5 4 16 3 Z"
      ></path>
      <path
        fill="none"
        stroke="#C4841D"
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        d="M16 17 C 13.5 19 12.5 21 12.5 23 C 12.5 25.5 14 27 16 27 C 18 27 19.5 25.5 19.5 23.5 C 19.5 22 18.5 20 17 18.5 C 16.5 18 16 17.5 16 17 Z"
      ></path>
    </symbol>
    <symbol id="i-bulb" viewBox="0 0 32 32">
      <path
        fill="#F5B041"
        stroke="#2E2437"
        strokeWidth="1.6"
        strokeLinejoin="round"
        d="M16 4 a9 9 0 0 1 6 15.5 c-1.2 1-1.8 2-2 3.5 h-8 c-.2-1.5-.8-2.5-2-3.5 A9 9 0 0 1 16 4 Z"
      ></path>
      <path
        fill="none"
        stroke="#2E2437"
        strokeWidth="1.6"
        strokeLinecap="round"
        d="M12.5 26h7M13.5 29h5"
      ></path>
    </symbol>
  </svg>
);

export default Icons;
